import React from 'react';
import { ShoppingCart, User, MessageCircle, Box } from 'lucide-react';
import Layout from 'layouts/manager/Layout';
import Chart from 'components/Chart';

const stats = [
  { title: 'New Orders', value: '150', icon: ShoppingCart, bg: 'bg-blue-100', text: 'text-blue-700' },
  { title: 'Users', value: '53%', icon: User, bg: 'bg-green-100', text: 'text-green-700' },
  { title: 'Messages', value: '44', icon: MessageCircle, bg: 'bg-yellow-100', text: 'text-yellow-700' },
  { title: 'Products', value: '65', icon: Box, bg: 'bg-red-100', text: 'text-red-700' },
];

const Dashboard: React.FC = () => {
  return (
    <Layout>
      <div className="grid grid-cols-1 gap-6 md:grid-cols-2 xl:grid-cols-4">
        {stats.map((stat) => (
          <div key={stat.title} className={`p-4 rounded-lg ${stat.bg} flex items-center`}>
            <stat.icon className={`w-8 h-8 mr-4 ${stat.text}`} />
            <div>
              <p className="text-xl font-semibold text-gray-700">{stat.value}</p>
              <p className="text-gray-500">{stat.title}</p>
            </div>
          </div>
        ))}
      </div>
      <Chart />
    </Layout>
  );
};

export default Dashboard;
